/* 2026-10-19 · PDP format switch continuity (CODE_TASK_PDP_FORMAT_SWITCH_CONTINUITY).
   Each format (tee / print / framed / Complete Edition) is its own product, so a
   format switch is a full navigation that would land at the top. On a format link
   tap this records where the Edition selector ([data-edition-anchor]) sits on screen;
   the inline script after the selector in snippets/buy-panel.liquid restores it.
   Never prevents the click and never touches the href (he-attribution.js owns it).
   Links: [data-edition-link] (place-first selector, Frame row, Complete line) and
   any link in the plain .edition__group, which carries no data-edition-link.
   REVERT: delete this file and its <script> in sections/product-archive-main.liquid. */
(function () {
  'use strict';
  var K = 'he_fmt_anchor';
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest && e.target.closest('a[data-edition-link], [data-edition-anchor] a[href]');
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
    var anchor = document.querySelector('[data-edition-anchor]');
    if (!anchor) return;
    var url;
    try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin || url.pathname === window.location.pathname) return;
    try {
      sessionStorage.setItem(K, JSON.stringify({
        path: url.pathname,
        top: Math.round(anchor.getBoundingClientRect().top),
        t: Date.now()
      }));
    } catch (err) {}
  }, true);
})();
